// @flow
import $ from 'jquery';
import StockholdersNewView from '../NewView';

export default class NewView extends StockholdersNewView {
  renderEditForm(select_stakeholder_id: number) {
    //itou バリデーションエラーで入力画面に戻るとなぜか参照されるルートパスが変わってしまうため遷移先URLを動的に定義する暫定対応
    const target = $('#stakeholder_from_stakeholder_id');
    var from_stakeholder_id = target.val();
    const url =
      location.pathname ==
      `/company/stockholders/${from_stakeholder_id}/newly_transfer_stakeholders`
        ? `/company/stockholders/${from_stakeholder_id}/newly_transfer_stakeholders/${select_stakeholder_id}/edit`
        : `${select_stakeholder_id}/edit`;
    $.ajax({
      url: url,
      type: 'GET',
      data: {
        select_stakeholder_id: select_stakeholder_id,
      },
      dataType: 'script',
    });
  }

  renderNewForm() {
    //itou バリデーションエラーで入力画面に戻るとなぜか参照されるルートパスが変わってしまうため遷移先URLを動的に定義する暫定対応
    const target = $('#stakeholder_from_stakeholder_id');
    var from_stakeholder_id = target.val();
    const url =
      location.pathname ==
      `/company/stockholders/${from_stakeholder_id}/newly_transfer_stakeholders`
        ? `/company/stockholders/${from_stakeholder_id}/newly_transfer_stakeholders/new`
        : 'new';
    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'script',
    });
  }
}
